import { Video } from "../models";
import { fetchAuthenticated } from "../scripts/custom-fetch";

export async function createVideo(video: Omit<Video, "id" | "createdAt" | "updatedAt">) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_POST}/videos`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(video),
  });

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as Video;
}

export async function updateVideo(videoId: number, video: Partial<Omit<Video, "id" | "createdAt" | "updatedAt">>) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_POST}/videos/${videoId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(video),
  });

  if (!response.ok) {
    throw new Error(await response.json());
  }
}

export async function getVideos() {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_GET}/videos`);

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as Video[];
}

export async function getVideo(videoId: number) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_GET}/videos/${videoId}`);

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as Video;
}